package com.siriusxm.cmc.views

import androidx.compose.runtime.Composable
import com.siriusxm.pia.Application
import com.siriusxm.pia.components.box
import com.siriusxm.pia.components.serviceContentView
import com.siriusxm.pia.components.serviceView
import com.siriusxm.pia.views.favorites.favoritesSection
import com.siriusxm.pia.views.news.newsSection
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

/**
 * The new home page for the management console.
 * Features an uber-search panel at the top with Search and Discovery modes,
 * followed by a two-column layout with applications (2/3) on the left
 * and favorites (1/3) on the right.
 */
@Composable
fun Home() {
    serviceView {
        serviceContentView {
            UberSearch()

            HomeContentLayout()
        }
    }
}

/**
 * A two-column layout displaying the applications list (2/3 width) on the left
 * and a stacked column (1/3 width) on the right with News above Favorites.
 * Both internal and external applications are shown, with external apps
 * displaying an icon to indicate they open in a new tab.
 */
@Composable
private fun HomeContentLayout() {
    val allApps = Application.configuration.applications.orEmpty()

    Div({
        style {
            display(DisplayStyle.Flex)
            gap(24.px)
            marginTop(24.px)
        }
    }) {
        // Left column - Applications (2/3 width)
        Div({
            style {
                flex(2)
                minWidth(0.px)
            }
        }) {
            box({
                title = "Applications"
                paddedContent = false
            }) {
                ApplicationList(allApps)
            }
        }

        // Right column - News and Favorites stacked (1/3 width)
        Div({
            style {
                flex(1)
                minWidth(0.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                // Match the page's 24px rhythm; boxes own no outer margin, so this column
                // owns the gap between the stacked News and Favorites sections.
                gap(24.px)
            }
        }) {
            // News section at the top
            newsSection()

            // Favorites section below
            favoritesSection()
        }
    }
}